var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Stack as ChakraStack } from "@chakra-ui/react";
/**
 * Stack is a layout utility component that makes it easy to stack elements together and apply a space between them.
 * It leverages power of css flex-box to quickly align an justify content.
 */
const Stack = forwardRef((_a, ref) => {
    var { className, shouldWrapChildren = true } = _a, rest = __rest(_a, ["className", "shouldWrapChildren"]);
    return (React.createElement(ChakraStack, Object.assign({}, rest, { ref: ref, className: className, shouldWrapChildren: shouldWrapChildren })));
});
Stack.displayName = "Stack";
export default Stack;
//# sourceMappingURL=Stack.js.map